'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import Layout from 'Layouts/Front';
import Breadcrumb from 'Components/Front/Breadcrumb';
import SearchWidget from 'Components/Front/SearchWidget';
import SearchedEstablishments from 'Components/Blocks/SearchedEstablishments';
import SearchResultsMap from 'Components/Front/SearchResultsMap';
import Loader from 'Pure/Loader';
import getWidgetValuesFromUrl from 'Functions/getWidgetValuesFromUrl';
import bemit from 'Functions/bemit';
import { coworking_place_types as type_options } from 'Shared/options';
import { getUrlParameter } from 'Shared/utilities';
import { URL } from 'Shared/Routes';
const app = window.app;
export default class SearchResultsPage extends Component {
  state = {
    search_id: uniqid(),
    widget: {
      ...getWidgetValuesFromUrl(),
      date: window.localStorage.getItem('widget-date') || ''
    },
    search_mode: getUrlParameter('mode') === 'recherche' ? 'raw' : getUrlParameter('mode') === 'autour' ? 'around' : undefined
  };
  first_fetch = false;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.pathname = props.history.location.pathname;
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const page_changed = props.history.location.pathname !== component.pathname;
    if (page_changed) {
      component.pathname = props.history.location.pathname;
      component.setState({
        search_id: uniqid()
      });
      component.emitTCEvent();
    }
  }
  handleFetch = ({
    data = []
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.first_fetch === false) {
      component.emitTCEvent();
    }
    component.first_fetch = true;
    component.setState({
      etablishments: data,
      map_id: uniqid()
    });
  };
  emitTCEvent = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const searched = document.location.pathname.split('/')[3];
    let type = document.location.pathname.split('/')[2] || type_options[0].value;
    if (type === 'tous') {
      type = 'all';
    } else if (type === 'seminaires') {
      type = 'b_seminar';
    } else {
      const match = type_options.find(opt => opt.value === type || opt.new_value === type);
      type = match ? match.TC_value : 'all';
    }
    const TC_data = {
      page: 'listing ' + type + (searched ? ' ' + searched.split('#')[0] : '')
    };
    if (searched) TC_data.ville_reservation = searched.split('#')[0];
    app.emit({
      event: 'TCPageView',
      source: 'SearchResultsPage',
      data: TC_data
    });
  };
  handleWidgetChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let state_name = name === 'widget-space-type' ? 'space-type' : name === 'widget-date' ? 'date' : name;
    component.setState({
      widget: {
        ...state.widget,
        [state_name]: value
      }
    });
  };
  handleUserLocated = user_location => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      user_location,
      location_ready: true,
      location_timeout: false
    });
  };
  handleMapMove = ({
    east,
    north,
    south,
    west
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component._move_timeout) {
      window.clearTimeout(component._move_timeout);
    }
    component._move_timeout = window.setTimeout(function () {
      component._move_timeout = undefined;
      component.setState({
        show_only_boundaries: true,
        min_lng: west,
        max_lng: east,
        min_lat: south,
        max_lat: north
      });
    }, 220);
  };
  onUserLocationRefused = info => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      location_ready: true,
      location_timeout: false
    });
  };
  handleLocationTimeout = info => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      location_timeout: true
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      type,
      city
    } = props.match.params;
    const url = '/recherche/' + type + (city ? '/' + city : '');
    const breadcrumb = [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'current-page',
      label: 'Recherche',
      url: url
    }];
    const location_loader = state.search_mode === 'around' && !state.location_ready && !state.location_timeout ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white', 'h-300'],
      text: "Demande d'acc\xE8s \xE0 la localisation de votre appareil..."
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['search-results-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__filter"
    }), /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "R\xE9sultats de recherche"), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__widget"
    }, /*#__PURE__*/React.createElement(SearchWidget, {
      bemit: ['search-results-page'],
      onChange: component.handleWidgetChange,
      "default-values": state.widget,
      search_mode: state.search_mode,
      onUserLocated: component.handleUserLocated,
      onUserLocationRefused: component.onUserLocationRefused,
      onLocationTimeout: component.handleLocationTimeout
    }))), /*#__PURE__*/React.createElement("div", {
      className: "search-results-container"
    }, /*#__PURE__*/React.createElement(SearchedEstablishments, {
      "search-results": true,
      bemit: ['search-results'],
      pagination: false,
      onFetch: component.handleFetch,
      key: state.search_id,
      date: state.widget.date,
      type: state.widget['space-type'],
      search_mode: state.search_mode,
      user_location: state.user_location,
      user_location_timeout: state.location_timeout,
      min_lat: state.min_lat,
      max_lat: state.max_lat,
      min_lng: state.min_lng,
      max_lng: state.max_lng,
      "show-only-in-boundaries": state.show_only_boundaries
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      bemit: ['no-padding', 'search-results'],
      links: breadcrumb
    })), /*#__PURE__*/React.createElement("div", {
      className: "search-results-map-container"
    }, state.map_id ? /*#__PURE__*/React.createElement(SearchResultsMap, {
      key: state.search_id,
      "search-id": state.map_id,
      etablishments: state.etablishments,
      user_location: state.user_location,
      onMove: component.handleMapMove
    }) : undefined), location_loader));
    return output;
  }
}
